import * as React from "react";
import { useTranslation } from "react-i18next";

import { Grid, Typography } from "@mui/material";

import digitalSignageImage from "../common/Images/digital-signage.jpg";

const DigitalSignage: React.FC = () => {
  const { t } = useTranslation("translation");

  return (
    <Grid id='digital-signage'>
      <Typography
        className='landing-section-heading landing-secondary-color landing-headers-orange-color'
        variant='h6'
        align='center'
      >
        {t("digitalSignage")}
      </Typography>

      <Grid className='landing-feature-margin' container spacing={2}>
        <img src={digitalSignageImage} alt='digital signage' width='87%' height='100%' />
      </Grid>
    </Grid>
  );
};

export default DigitalSignage;
